import React from 'react';
import { useServerStatus } from '../contexts/ServerStatusContext';
import './ServerErrorIndicator.css';

const ServerErrorIndicator: React.FC = () => {
  const { showErrorIndicator, setShowErrorIndicator } = useServerStatus();

  if (!showErrorIndicator) return null;

  return (
    <div className="server-error-indicator">
      <div className="error-content">
        <span className="error-icon text-white">⚠️ Servidor não está acessível</span>
        <button 
          className="error-close"
          onClick={() => setShowErrorIndicator(false)}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ServerErrorIndicator;